<template>
  <messenger @locale-changed="handleLocaleChanged">
    <template v-slot:header>
      <div class="flex flex-col gap-2 px-6 items-center text-center">
        <Loom class="w-12 h-12 text-white" />
        <h1 class="text-white text-2xl font-semibold">
          {{
            t("components.messenger.welcome.title", {
              tenant: tenant.name,
            })
          }}
        </h1>
        <p class="text-white">
          {{ t("components.messenger.welcome.description") }}
        </p>
      </div>
    </template>
    <template v-slot:content>
      <div
        v-if="!isSpaceSelectionDisabled && hasLocations"
        class="flex flex-col h-full gap-4 p-4"
      >
        <span class="text-sm font-medium text-gray-500">
          {{ t("components.messenger.welcome.select") }}
        </span>

        <div class="flex flex-col justify-between grow">
          <LocationDropdown
            :placeholder="t('components.messenger.welcome.space')"
            :spaces="props.hierarchical_spaces"
            :assets="props.hierarchical_assets"
            :tenants="[tenant]"
            disable-groups
            disable-ungrouped
            selector-style="dropdown"
            :model-value="lastSpace"
            @update:model-value="handleSpaceSelected"
          />

          <primary-button
            v-if="!isSpaceSelectionDisabled && hasLocations"
            :label="t('components.messenger.welcome.cta')"
            @click="handleContinue"
            :loading="isLoading"
            :disabled="!lastSpace"
            class="sm:mt-4"
          />
        </div>
      </div>
      <div class="p-40" v-else-if="isSpaceSelectionDisabled">
        <MessengerEmptyScreen
          :title="t('components.spaces.disabled.title')"
          :description="t('components.spaces.disabled.description')"
          :image="'/images/empty/error.svg'"
        />
      </div>
      <div class="p-40" v-else-if="!hasLocations">
        <MessengerEmptyScreen
          :title="t('components.spaces.empty.title')"
          :description="t('components.spaces.empty.description')"
          :image="'/images/empty/error.svg'"
        />
      </div>
    </template>
  </messenger>
</template>

<script setup>
import { ref } from "vue";
import { usePage } from "@inertiajs/vue3";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton.vue";
import Messenger from "@/Tailwind/Layouts/Messenger.vue";
import { useCookies } from "vue3-cookies";
import { useI18n } from "vue-i18n";
import LocationDropdown from "@/Tailwind/Components/Input/LocationDropdown.vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import Loom from "@/Tailwind/Icon/Loom.vue";
import MessengerEmptyScreen from "@/Tailwind/Components/Messenger/MessengerEmptyScreen.vue";

const { t } = useI18n();

const props = defineProps({
  hierarchical_spaces: { type: Array, required: true },
  hierarchical_assets: { type: Array, required: true },
});

const isLoading = ref(false);
const tenant = usePage().props.tenant;
const locale = usePage().props.locale;
const hasLocations = usePage().props.has_locations;
const isSpaceSelectionDisabled =
  usePage().props.tenant.settings.disable_space_selection;

const lastSpace = ref();
const { cookies } = useCookies();

const currentLocale = ref(cookies.get("messenger_locale") || locale);

function handleLocaleChanged(locale) {
  currentLocale.value = locale;
}

function handleSpaceSelected(space) {
  if (!space) {
    return;
  }

  lastSpace.value = space;
}

function handleContinue() {
  router.get(
    route("problem.detect", [tenant.slug, lastSpace.value.id]),
    {},
    {
      onStart: () => (isLoading.value = true),
      onFinish: () => (isLoading.value = false),
    }
  );
}
</script>
